<template>
    <div>
        
        <h1>Gruppen & Vereine</h1>


        Wir planen & organisieren Fahrten für Schulklassen, Vereine, Betriebe und Seniorengruppen. Gerne gehen wir auf Ihre speziellen Wünsche ein. Garantiert unverbindlich und kostenlos erhalten Sie Tipps, Anregungen und Ideen zu Ihrer geplanten Gruppenreise.
        <br><br>
        Wir sind Ihr Partner bei der Planung Ihrer Busfahrt. Ob mit Übernachtung, Stadtrundfahrt, Mittagessen, Besichtigungen etc. – wir können Ihnen Ihre individuellen Wünschen organisieren. Auch Familien oder gesellige Freundeskreise profitieren von unserem speziellen Gruppenarrangement.
        <br><br>
        Wir bieten Ihnen komfortabel ausgestattete Busse mit unterschiedlichen Platzkapazitäten. Informationen erhalten sie unter folgendem Link: <a href="#/article/Busflotte"> Busflotte </a>



        <h2>Angaben zur Reise</h2>
        <p style="text-align:left">Ich interessiere mich für*</p>

        <el-row style="color:black;font-weight:bold"><el-radio name="Interesse" v-validate="'required'" label="Gruppenreise/Studienreise (Erwachsene)" v-model="form.Interesse"></el-radio></el-row>
        <el-row style="color:black;font-weight:bold"><el-radio name="Interesse" label="Klassenfahrten/Reisen für Jugendgruppen" v-model="form.Interesse"></el-radio></el-row>
        <el-row style="color:black;font-weight:bold"><el-radio name="Interesse" label="Transfer" v-model="form.Interesse"></el-radio></el-row>

        <p style="text-align: left">Gewünschtes Reiseziel</p>

        <el-row :gutter="10">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
            <el-col :xs="23" :sm="11" :md="11" :lg="11" :xl="11"
                ><div>Land</div>
                <el-select style="width: 100%" v-model="form.Land" placeholder="Bitte wählen"><el-option v-for="item in optionsLand" :key="item" :label="item" :value="item"></el-option></el-select
            ></el-col>
            <el-col :xs="23" :sm="11" :md="11" :lg="11" :xl="11"
                ><div>PLZ/Ort</div>
                <el-input v-model="form.Reiseziel_PLZ_Ort" placeholder="PLZ/Ort"></el-input
            ></el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
        </el-row>
        <p style="text-align: left">Gewünschter Reisetermin</p>

        <el-row :gutter="10">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
            <el-col :xs="23" :sm="11" :md="11" :lg="11" :xl="11"
                ><div class="block">
                    <div>Hinfahrt</div>
                    <el-date-picker style="width: 100%" v-model="form.Hinfahrt" placeholder="TT.MM.JJJJ" format="dd.MM.yyyy"> </el-date-picker></div
            ></el-col>
            <el-col :xs="23" :sm="11" :md="11" :lg="11" :xl="11"
                ><div>Uhrzeit</div>
                <el-input v-model="form.Abfahrtszeit" placeholder="08:00 Uhr"></el-input
            ></el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
            <el-col :xs="23" :sm="11" :md="11" :lg="11" :xl="11"
                ><div class="block">
                    <div>Rückfahrt</div>
                    <el-date-picker style="width: 100%" v-model="form.Rueckfahrt" placeholder="TT.MM.JJJJ" format="dd.MM.yyyy"> </el-date-picker></div
            ></el-col>
            <el-col :xs="23" :sm="11" :md="11" :lg="11" :xl="11"
                ><div>Uhrzeit</div>
                <el-input v-model="form.Rueckfahrtszeit" placeholder="08:00 Uhr"></el-input
            ></el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
            <el-col :xs="23" :sm="22" :md="22" :lg="22" :xl="22"
                ><div>Personenzahl</div>
                <el-input v-model="form.Personenzahl" placeholder=""></el-input
            ></el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
            <el-col :xs="23" :sm="22" :md="22" :lg="22" :xl="22"
                ><div>Reiseverlauf</div>
                <el-input type="textarea" v-model="form.Reiseverlauf" :rows="4" placeholder=""></el-input
            ></el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
            <el-col :xs="23" :sm="22" :md="22" :lg="22" :xl="22"
                ><div>Sonstiges</div>
                <el-input type="textarea" v-model="form.Sonstiges" :rows="4" placeholder=""></el-input
            ></el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
        </el-row>

        <h2>Angaben zur Reise</h2>
        <p style="text-align: left">Angaben zur Person</p>

        <el-row :gutter="10">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
            <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"
                ><div>Anrede</div>
                <el-input v-model="form.Anrede" placeholder=""></el-input
            ></el-col>
            <el-col :xs="1" :sm="2" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
            <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"
                ><div>Titel</div>
                <el-input v-model="form.Titel" placeholder=""></el-input
            ></el-col>
            <el-col :xs="1" :sm="2" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
            <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"
                ><div>Name der Institution / Verein / Schule</div>
                <el-input v-model="form.Name_Institution" placeholder=""></el-input
            ></el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
            <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"
                ><div>Vorname*</div>
                <el-input v-model="form.Vorname" placeholder="" name="Vorname" v-validate="'required'"></el-input
            ></el-col>
            <el-col :xs="1" :sm="2" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
            <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"
                ><div>Name*</div>
                <el-input v-model="form.Name" placeholder="" name="Name" v-validate="'required'"></el-input
            ></el-col>
            <el-col :xs="1" :sm="2" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
            <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"
                ><div>E-Mail</div>
                <el-input v-model="form.Email" placeholder=""></el-input
            ></el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
            <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"
                ><div>Straße*</div>
                <el-input v-model="form.Straße" placeholder="" name="Straße" v-validate="'required'"></el-input
            ></el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
            <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"
                ><div>Hausnr.*</div>
                <el-input v-model="form.Hausnr" placeholder="" name="Hausnummer" v-validate="'required'"></el-input
            ></el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
            <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"
                ><div>Telefon</div>
                <el-input v-model="form.Telefon" placeholder=""></el-input
            ></el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
            <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"
                ><div>PLZ*</div>
                <el-input v-model="form.PLZ" placeholder="" name="PLZ" v-validate="'required'"></el-input
            ></el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
            <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"
                ><div>Ort*</div>
                <el-input v-model="form.Ort" placeholder="" name="Ort" v-validate="'required'"></el-input
            ></el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
            <el-col :xs="23" :sm="23" :md="4" :lg="3" :xl="6"
                ><div>Fax</div>
                <el-input v-model="form.Fax" placeholder=""></el-input
            ></el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
        </el-row>
        <br />
        <b>Wie sind Sie auf uns aufmerksam geworden?</b> <br />

        <el-row :gutter="10">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
            <el-col :xs="23" :sm="14" :md="14" :lg="14" :xl="14"
                ><el-select style="width: 100%" v-model="form.Aufmerksamkeit" placeholder="Bitte wählen"><el-option v-for="item in optionsaufmerksam" :key="item.value" :label="item.label" :value="item.value"></el-option></el-select
            ></el-col>
        </el-row>
        <br />

        <el-row>
            <!-- `checked` should be true or false -->
            <el-checkbox v-model="form.Datenschutz" style="font-weight: bold" name="Datenschutz" v-validate="'required:invalidateFalse'">&nbsp;</el-checkbox> Ja, ich habe die <a href="#/article/Datenschutz">Datenschutzerklärung</a> zur Kenntnis genommen und bin damit einverstanden, dass die von mir angegebenen Daten elektronisch erhoben und gespeichert werden. Meine Daten werden dabei nur streng zweckgebunden zur Bearbeitung und Beantwortung meiner Anfrage genutzt.
        </el-row>
        <br />

        <el-row>
            <!-- `checked` should be true or false -->
            <el-checkbox v-model="form.AGB" style="font-weight: bold" name="AGB" v-validate="'required:invalidateFalse'">&nbsp;</el-checkbox>Ja, ich habe die <a href="#/article/AGB">Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiere diese.
        </el-row>
        <br />

        <el-button @click="onSubmit" type="primary">Anfrage senden</el-button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            text: "",
            optionsLand: ["Deutschland", "Schweiz", "Schweden", "Frankreich", "Großbritannien", "Polen", "Norwegen", "Niederlande", "Österreich", "Ungarn", "Italien", "Slowenien", "Tschechische Republik", "Kroatien", "Slowakei", "Island", "Dänemark", "Zypern", "Rumänien", "Litauen"],
            AGB: false,
            Datenschutz: false,
            optionsaufmerksam: [
                {
                    value: "Google",
                    label: "Google",
                },
                {
                    value: "Reisebüro",
                    label: "Reisebüro",
                },
                {
                    value: "Freunde",
                    label: "Freunde/Bekannte",
                },
                {
                    value: "Sonstiges",
                    label: "Sonstiges",
                },
            ],
            form: {
                Name_Institution: null,
                Anrede: null,
                Titel: "",
                Vorname: null,
                Name: "",
                Straße: "",
                Hausnr: "",
                PLZ: "",
                Ort: "",
                Email: "",
                Telefon: "",
                Fax: "",

                radio: null,
                Reiseziel_PLZ_Ort: "",
                Land: null,
                Hinfahrt: null,
                Abfahrtszeit: null,
                Rueckfahrt: null,
                Rueckfahrtszeit: null,
                Personenzahl: null,
                Reiseverlauf: "",
                Sonstiges: null,
                Aufmerksamkeit: null,

                // subject: "Busanmietung",
                // Betreff: "",
                // Nachricht: "",
            },
        }
    },
    mounted() {
        // this.text = content.find(item => item.id == 13).text
    },
    methods: {
        onSubmit() {
            this.$validator.validate().then((result) => {
                if (!result) {
                    this.$alert(this.errors.all().join("<br>"), "Fehler", { dangerouslyUseHTMLString: true })
                    return
                }

                let formData = new FormData()
                for (const key in this.form) {
                    if (key == "Hinfahrt" || key == "Rueckfahrt") {
                        try {
                            formData.append(key, new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).format(this.form[key]))
                        } catch (error) {
                            formData.append(key, this.form[key])
                        }
                    } else {
                        formData.append(key, this.form[key])
                    }
                }

                fetch("php/mail_action.php", { method: "POST", body: formData })
                    .then((res) => res.text())
                    .then((jsonData) => {
                        this.form = {}
                        this.$alert("Vielen Dank für Ihre Nachricht, wir werden uns in Kürze bei Ihnen melden.", "Mail versendet", { dangerouslyUseHTMLString: true })
                    })
                    .catch((error) => {
                        this.$alert("Die E-Mail konnte leider nicht versendet werden.", "Fehler", { dangerouslyUseHTMLString: true })
                        return
                    })
            })
        },
    },
}
</script>

<style scoped>
.el-input,
.el-button {
    width: 100%;
}

textarea {
    resize: none;
}

.el-button {
    width: 100%;
    background-color: #ee9301;
    border: none;
}
</style>